import { render } from "./latestTab.vue?vue&type=template&id=d4dc4a66"
import script from "./latestTab.vue?vue&type=script&lang=js"
export * from "./latestTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__